import { GeneralCalculationState } from './generalCalculation';

export const BracketAttachmentState = GeneralCalculationState;



// WEBPACK FOOTER //
// ./src/reducers/options/panel/defaults/bracketAttachment.js